export const TEMPORAL = "TEMPORAL";
export const DRAFT = "DRAFT";
export const CANCELLED = "CANCELLED";
export const APPROVED = "APPROVED";
export const IN_COURSE = "IN_COURSE";
export const DONE = "DONE";
export const APPROVED_AND_DRAFT = "APPROVED_AND_DRAFT";

export const FILTER_TASK_STATES_VALUES = [TEMPORAL, DRAFT, CANCELLED, APPROVED, IN_COURSE, DONE, APPROVED_AND_DRAFT];
